import { If, reactive, watch } from 'cdui-js';
import { getImageUrl } from '../utils/common';
import { IconPhotoPlaceholder } from './icons';

export type BrokerMarkProps = {
  name: string;
  /** 相对路径（如 upload/...）、http(s)、blob、或打包静态资源 URL */
  logo?: string;
  large?: boolean;
};

/** 券商 logo：相对路径拼 VITE_IMG_BASE_URL（pre → https://file.difisec.vip/file/） */
const resolveBrokerLogoSrc = (raw?: string) => {
  const logo = String(raw || '').trim();
  if (!logo) return '';
  if (/^https?:\/\//i.test(logo) || logo.startsWith('blob:') || logo.startsWith('data:')) {
    return logo;
  }
  // Vite 打包静态资源（如 /assets/...）
  if (logo.startsWith('/') && !logo.startsWith('/upload') && !logo.startsWith('/file')) {
    return logo;
  }
  return getImageUrl(logo.replace(/^\//, ''));
};

export const BrokerMark = (props: BrokerMarkProps) => {
  const state = reactive({ imgError: false });

  watch(
    () => props.logo,
    () => {
      state.imgError = false;
    },
  );

  const src = () => (state.imgError ? '' : resolveBrokerLogoSrc(props.logo));
  const className = props.large ? 'sti-logo sti-logo-panel' : 'sti-logo';

  return (
    <span class={className} aria-label={props.name || undefined}>
      <If when={!!src()}>
        <img
          src={src()}
          alt=""
          onerror={() => {
            state.imgError = true;
          }}
        />
      </If>
      <If when={!src()}>
        <IconPhotoPlaceholder class="sti-logo-placeholder" />
      </If>
    </span>
  );
};
